import React from "react";
import {
  FaUser,
  FaPhoneAlt,
  FaEnvelope,
  FaMobileAlt,
  FaCommentDots,
  FaPaperPlane,
} from "react-icons/fa";

import "./ContactForm.css";

function ContactForm() {
  return (
    <section className="contact-form-section">
      <div className="container">
        <div
          className="contact-form-card"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="section-heading text-center">
            <span className="section-badge">Send Inquiry</span>

            <h2 className="section-title">Request Mobile Repair Service</h2>

            <p className="section-description">
              Fill out the form below and our team will contact you shortly.
            </p>
          </div>

          <form>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label>Name *</label>

                <div className="input-group-custom">
                  <FaUser />

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                  />
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <label>Phone Number *</label>

                <div className="input-group-custom">
                  <FaPhoneAlt />

                  <input
                    type="tel"
                    className="form-control"
                    placeholder="+971 50 123 4567"
                  />
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <label>Email (Optional)</label>

                <div className="input-group-custom">
                  <FaEnvelope />

                  <input
                    type="email"
                    className="form-control"
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <label>Device Model</label>

                <div className="input-group-custom">
                  <FaMobileAlt />

                  <input
                    type="text"
                    className="form-control"
                    placeholder="iPhone 15 Pro"
                  />
                </div>
              </div>
            </div>

            <div className="mb-4">
              <label>Issue Description *</label>

              <div className="input-group-custom textarea-group">
                <FaCommentDots />

                <textarea
                  rows="5"
                  className="form-control"
                  placeholder="Describe the issue with your device..."
                ></textarea>
              </div>
            </div>

            <button type="submit" className="btn submit-btn">
              <FaPaperPlane />

              <span>Send Inquiry</span>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
